import { Link } from "react-router-dom";
import { Card } from "reactstrap";

import PageFrame from "../../helpers/PageFrame/PageFrame";
import Footer from "./../../helpers/Footer/Footer";
import { Block } from "../../components/Block/Block";

const AuthLayout = ({ children }) => {
  return (
    <PageFrame>
      <Block className="nk-block-middle nk-auth-body wide-xs">
        <div className="brand-logo pb-4 text-center">
          <Link to="/" className="logo-link">
            <img
              className="logo-light logo-img logo-img-xl"
              src="/assets/images/logo.png"
              alt="logo"
            />
            <img
              className="logo-dark logo-img logo-img-xl"
              src="/assets/images/logo-dark.png"
              alt="logo-dark"
            />
          </Link>
        </div>

        <Card className="card-preview card-bordered">
          <div className="card-inner card-inner-lg">{children}</div>
        </Card>
      </Block>
      <Footer />
    </PageFrame>
  );
};

export default AuthLayout;
